import { GoodsSupplyCase } from 'features/goods-supply';
import React from 'react';
import { RegularButton, Typography } from 'fronton-react';
import { WarningCircleIcon } from '@fronton/icons-react';
import { useTranslation } from 'react-i18next';
import { analyticsUtils } from 'utils';
import * as styles from './pdp-availability-to-buy.styles';
import { useSelector } from 'react-redux';
import { getBreadcrumbs } from 'features/page-model';

export const DATA_QA_OUT_OF_STOCK_LABEL = 'out-of-stock-label';
export const DATA_QA_UNAVAILABLE_LABEL = 'unavailable-label';
export const DATA_QA_IS_AVAILABLE_FOR_ORDER = 'is-available-for-order';
export const DATA_QA_SHOW_SIMILAR_BUTTON = 'show-similar-button';

const scrollToAnchor = () => {
  analyticsUtils.sendEvent('GA:clickButton', {
    elementType: 'button',
    elementBlock: 'productDetail',
    elementName: 'outOfStock',
    elementText: 'Похожие',
  });
};

type GoodIsOutOfStockContentProps = { hideButton?: boolean };

export const GoodIsOutOfStockContent: React.FC<GoodIsOutOfStockContentProps> = ({ hideButton }) => {
  const { t } = useTranslation();
  const breadcrumbs = useSelector(getBreadcrumbs) || [];
  const lastBreadcrumbLink = breadcrumbs[breadcrumbs.length - 1]?.link;

  return (
    <div className={styles.unableToBuyNote} data-qa={DATA_QA_OUT_OF_STOCK_LABEL}>
      <WarningCircleIcon type="fill" size="m" color="attention-primary" />
      <Typography size="body_accent" variant="s" color="attention-primary">
        {t('product-info.availability.out-of-stock')}
      </Typography>
      {!hideButton && (
        <RegularButton
          href={lastBreadcrumbLink}
          onClick={scrollToAnchor}
          variant="secondary"
          data-qa={DATA_QA_SHOW_SIMILAR_BUTTON}
          className={styles.showSimilarButton}
        >
          {t('product-info.availability.show-similar')}
        </RegularButton>
      )}
    </div>
  );
};

export const IsUnavailableForOrderContent: React.FC = () => {
  const { t } = useTranslation();
  const breadcrumbs = useSelector(getBreadcrumbs) || [];
  const lastBreadcrumbLink = breadcrumbs[breadcrumbs.length - 1]?.link;

  return (
    <div className={styles.unableToBuyNote} data-qa={DATA_QA_UNAVAILABLE_LABEL}>
      <WarningCircleIcon type="fill" size="m" color="attention-primary" />
      <Typography size="body_accent" variant="s" color="attention-primary">
        {t('product-info.availability.unavailable')}
      </Typography>
      <RegularButton
        className={styles.showSimilarButton}
        onClick={scrollToAnchor}
        variant="secondary"
        data-qa={DATA_QA_SHOW_SIMILAR_BUTTON}
        href={lastBreadcrumbLink}
      >
        {t('product-info.availability.show-similar')}
      </RegularButton>
    </div>
  );
};

const IsAvailableForOrderContent: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Typography
      size="body_accent"
      variant="s"
      color="success-dark"
      className={styles.isAvailableNote}
      data-qa={DATA_QA_IS_AVAILABLE_FOR_ORDER}
    >
      {t('product-info.availability.available')}
    </Typography>
  );
};

export const ContentBySupplyCase: React.FC<{ supplyCase: GoodsSupplyCase }> = ({ supplyCase }) => {
  let content: React.ReactNode = null;
  switch (supplyCase) {
    case 'CASE_2':
      content = <IsUnavailableForOrderContent />;
      break;
    case 'CASE_1':
    case 'CASE_5':
      content = <GoodIsOutOfStockContent />;
      break;
    case 'CASE_3':
    case 'CASE_4':
    case 'CASE_6':
    case 'CASE_7':
    case 'CASE_8':
      content = <IsAvailableForOrderContent />;
      break;
  }
  return <>{content}</>;
};
